import { createFileRoute } from '@tanstack/react-router';
import { runsQuery } from '@/features/runs/api';
import { RunsPage } from '@/features/runs/pages/RunsPage';
import { runsSearchSchema } from '@/features/runs/search';
import { sourcesQuery } from '@/features/sources/api';

export const Route = createFileRoute('/_authed/ops/runs/')({
  staticData: { help: 'runs' },
  validateSearch: runsSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps }) => {
    void queryClient.prefetchQuery(runsQuery(deps));
    void queryClient.prefetchQuery(sourcesQuery());
  },
  component: RunsPage,
});
